
import TheCategoriesLabels from '~/components/Layout/TheCategoriesLabels.vue';
import { useGetTranslations } from '@/composables/useGetTranslations';
export default {
  name: 'CategoriesSisters.vue',
  props: {
    categories: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    TheCategoriesLabels,
  },
  setup() {
    const { translate } = useGetTranslations();

    return {
      translate,
    };
  },
};
